import { useState } from "react";
import { ContactRound, Phone, Mail, ArrowRight, Globe } from "lucide-react";
import LivingCanvas from "../../components/marketing/LivingCanvas";
import BrainViz from "../../components/marketing/BrainViz";
import Seo from "../../components/seo/Seo";
import logoWhite from "../../assets/brand/logo-white.svg";
import "./DavidCard.css";

const VCARD = `BEGIN:VCARD
VERSION:3.0
N:Lopez;David;;;
FN:David Lopez
ORG:Data Chimp Labs
TITLE:Engineering
TEL;TYPE=CELL:+13055277237
EMAIL:david.lopez@datachimplabs.com
URL:datachimplabs.com
END:VCARD`;

const downloadVCard = () => {
  const blob = new Blob([VCARD], { type: "text/vcard" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "david-lopez.vcf";
  a.click();
  URL.revokeObjectURL(url);
};

const DavidCard = () => {
  const [copied, setCopied] = useState(null);

  const copy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(null), 2000);
  };

  return (
    <>
      <Seo
        title="David Lopez — Engineering | Data Chimp Labs"
        description="David Lopez, Engineering at Data Chimp Labs."
        pathname="/team/david-lopez/card"
        noIndex
      />

      <LivingCanvas />

      <div className="biz-card-shell">
        <main className="biz-card biz-card--no-photo">
          <div className="biz-card__body">
            <h1 className="biz-card__name">David Lopez</h1>
            <a href="https://datachimplabs.com" target="_blank" rel="noopener noreferrer" className="biz-card__title">
              Engineering <span style={{ color: "var(--color-text-primary)" }}>@ Data Chimp Labs</span>
            </a>
            <p className="biz-card__desc">
              Building the operating brain for healthcare organizations.
            </p>

            <div className="biz-card__contacts">
              <div className="biz-card__contact-row">
                <a href="tel:+13055277237" className="biz-card__cta-icon">
                  <Phone size={20} />
                </a>
                <a href="tel:+13055277237" className="biz-card__contact-item">
                  <span className="biz-card__contact-label">Phone</span>
                  <span className="biz-card__contact-value">(305) 527-7237</span>
                </a>
                <button
                  className="biz-card__copy-btn"
                  onClick={() => copy("(305) 527-7237", "phone")}
                  type="button"
                >
                  {copied === "phone" ? "Copied!" : "Copy"}
                </button>
              </div>

              <div className="biz-card__contact-row">
                <a href="mailto:david.lopez@datachimplabs.com" className="biz-card__cta-icon">
                  <Mail size={20} />
                </a>
                <a href="mailto:david.lopez@datachimplabs.com" className="biz-card__contact-item">
                  <span className="biz-card__contact-label">Email</span>
                  <span className="biz-card__contact-value">david.lopez@datachimplabs.com</span>
                </a>
                <button
                  className="biz-card__copy-btn"
                  onClick={() => copy("david.lopez@datachimplabs.com", "email")}
                  type="button"
                >
                  {copied === "email" ? "Copied!" : "Copy"}
                </button>
              </div>
            </div>

            <div className="biz-card__cta-group">
              <div className="biz-card__cta-row">
                <button className="biz-card__cta-icon" onClick={downloadVCard} type="button">
                  <ContactRound size={20} />
                </button>
                <button
                  className="biz-card__cta-btn"
                  onClick={downloadVCard}
                  type="button"
                >
                  <span className="biz-card__contact-label">vCard</span>
                  <span className="biz-card__contact-value">Add to Contacts</span>
                </button>
                <button className="biz-card__cta-arrow" onClick={downloadVCard} type="button">
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>

            <div className="biz-card__divider" />

            <div className="biz-card__company-block">
              <BrainViz className="biz-card__company-canvas" />

              <a href="https://datachimplabs.com" target="_blank" rel="noopener noreferrer">
                <img
                  src={logoWhite}
                  alt="Data Chimp Labs"
                  className="biz-card__logo"
                  width="160"
                  height="45"
                />
              </a>

              <p className="biz-card__company-desc">
                Building the operating brain for healthcare organizations. AI-powered intelligence that helps operators move faster, cut waste, and deliver better outcomes.
              </p>

              <div className="biz-card__cta-row">
                <a href="https://datachimplabs.com" target="_blank" rel="noopener noreferrer" className="biz-card__cta-icon">
                  <Globe size={20} />
                </a>
                <a
                  href="https://datachimplabs.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="biz-card__cta-btn"
                >
                  <span className="biz-card__contact-label">Website</span>
                  <span className="biz-card__contact-value">datachimplabs.com</span>
                </a>
                <a href="https://datachimplabs.com" target="_blank" rel="noopener noreferrer" className="biz-card__cta-arrow">
                  <ArrowRight size={16} />
                </a>
              </div>
            </div>

          </div>
        </main>
      </div>

      <div className="biz-card__sticky-actions">
        <div className="biz-card__sticky-inner">
          <a
            href="mailto:david.lopez@datachimplabs.com"
            className="button button-secondary biz-card__btn"
          >
            Email Now
          </a>

          <a
            href="tel:+13055277237"
            className="button button-primary biz-card__btn"
          >
            Call Now
          </a>
        </div>
      </div>
    </>
  );
};

export default DavidCard;
